import React, { useState } from 'react';
import ReactModal from 'react-modal';
import Button from '../button';
import styles from './style.module.css';
import { FaCheckCircle } from 'react-icons/fa';
import Checkbox from '../checkbox/index';
import { Loader } from 'lucide-react';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  btnText: string;
  isLoading?: boolean;
  content: React.ReactNode;
  onConfirm: (isChecked: boolean) => void;
};

const TermsModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  btnText,
  onConfirm,
  isLoading,
  ...rest
}) => {
  const [isChecked, setIsChecked] = useState(false);
  if (!isOpen) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center w-full h-full bg-gray-500 bg-opacity-50">
      <div className="relative p-4 w-full max-w-3xl max-h-[90vh] overflow-y-auto bg-white rounded-lg shadow-lg">
        <button
          type="button"
          className="flex absolute top-3 right-3 justify-center items-center w-8 h-8 text-sm text-gray-400 bg-transparent rounded-lg hover:bg-gray-200 hover:text-gray-900"
          onClick={onClose}
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
        <div className="p-4 text-center">
          <h3 className="mb-5 text-lg font-bold">{title}</h3>
          <div className="mb-4 border rounded-md p-3 text-left h-[500px] scrollbar-always-visible ">
            {content}
          </div>
          {/* Checkbox for accepting terms */}
          <Checkbox
            id="terms-checkbox"
            label="I agree to the Terms and Conditions"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
            className="mb-4"
          />
          <div className="flex gap-4 justify-center">
            <Button
              type="button"
              onClick={() => onConfirm(isChecked)}
              disabled={!isChecked}
              className="mt-6 w-full"
            >
              {isLoading ? <Loader className="animate-spin size-5" /> : btnText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
